import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import book from './book.JPG'
import { BookList } from '../../enums';
import { BOOK_TITLE, MAIN_TITLE } from '../../config';

const styles = {
    root: {
        //backgroundImage: url('../Assets/icons/Background.png'),
        backgroundRepeat: 'no - repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        height: '100vh'
    },
    title: {
        marginTop: '7vh',
        marginBottom: '4vh',
        fontSize: '42px'
    }
}


const Loader = (props) => {

    const {
        handleSelectBook
    } = props

    return (
        <Container fluid className="root-loader">
            <Row style={styles.title} className="justify-content-sm-center text-center">
                <Col sm lg="4" style={{ backgroundColor: '#ffc107', padding: '15px' }}>
                    <div>{MAIN_TITLE}</div>
                </Col>
            </Row>
            <Row className="justify-content-sm-center">
                <Col className=" my-hover" sm lg="3" onClick={handleSelectBook(BookList.book_1)}>
                    <Card style={{ margin: 'auto', width: '18vw'}}>
                        <Card.Img variant="top" src={book} style={{ width: 'inherit'}}/>
                        <Card.Body>
                            <Card.Title className="text-center"  >{BOOK_TITLE}</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}


export default Loader